<div class="attachments-list-grid">
  @for (attachment of attachments; track trackByAttachment($index, attachment)) {
    <rt-attachment-item
      [type]="small ? 'compact-card' : 'card'"
      [attachment]="attachment"
      [hasDeleteAction]="canManageCandidates && deletable"
      [moreTemplate]="moreTemplate"
      [hasSetAsCvAction]="canManageCandidates && candidateActionsEnabled"
      [hasSetAsCoverLetterAction]="
        canManageCandidates && candidateActionsEnabled && hasSetAsCoverLetterAction
      "
      (setAsCv)="setAsCv.emit(attachment)"
      (setAsCoverLetter)="setAsCoverLetter.emit(attachment)"
      (deleteClick)="deleteClick.emit(attachment)"
    >
    </rt-attachment-item>
  }
</div>
